/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: c3d9d0a0 (Wed Sep 23 18:58:40 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface Timezone
 */
export interface Timezone {
  /**
   * The timezone is in the IANA time zone format i.e. America/New_York
   * @type string
   * @memberof Timezone
   */
  name: string
  /**
   * The timezone is in the IANA time zone format i.e. America/New_York
   * @type number
   * @memberof Timezone
   */
  offset: number
}

export function TimezoneFromJSON(json: any): Timezone {
  return TimezoneFromJSONTyped(json, false)
}

export function TimezoneFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): Timezone {
  if (json === undefined || json === null) {
    return json
  }
  return {
    name: json['name'],
    offset: json['offset'],
  }
}

export function TimezoneToJSON(value?: Timezone | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    name: value.name,
    offset: value.offset,
  }
}
